export type SavingIndicatorStatus = "saving" | "error" | "saved" | "locked" | "validated" | "pending" | "syncError"

const STATUS_ICONS: Partial<Record<SavingIndicatorStatus, string>> = {
    error: "mdi-alert-circle",
    syncError: "mdi-alert-circle",
    saved: "mdi-cloud-check",
    pending: "mdi-cloud-upload-outline",
    locked: "mdi-lock",
    validated: "mdi-check-circle-outline"
}

const STATUS_COLORS: Partial<Record<SavingIndicatorStatus, string>> = {
    error: "red",
    syncError: "red",
    saved: "green",
    pending: "orange",
    locked: "red",
    validated: "blue"
}

/**
 * Single source of truth for the icon shown by a given saving/sync status —
 * shared by the SavingIndicator component and anywhere else (e.g. list cards)
 * that needs to render the same status without duplicating the mapping.
 *
 * @param status
 */
export function getSavingIndicatorIcon(status: SavingIndicatorStatus): string {
    return STATUS_ICONS[status] ?? ""
}

/**
 * Single source of truth for the color shown by a given saving/sync status.
 *
 * @param status
 */
export function getSavingIndicatorColor(status: SavingIndicatorStatus): string {
    return STATUS_COLORS[status] ?? ""
}
